import { Pipe, PipeTransform } from '@angular/core';

import * as Hypher from 'hypher';
import * as german from 'hyphenation.de';

@Pipe({
    standalone: false,
    name: 'hyphenate',
    pure: true
})
export class Hyphenate implements PipeTransform {
    private hypher: Hypher;

    constructor() {
        const hyphenateLanguage = german;
        // I chose 4,3 min lengths to prevent someugly breakes for 'ver-fügbar' and 'Burnout-Prophyla-xe' on the modules
        hyphenateLanguage.leftmin = 4;
        hyphenateLanguage.rightmin = 3;

        hyphenateLanguage.exceptions = 'INFINKON';

        this.hypher = new Hypher(hyphenateLanguage);
    }

    transform(text?: string): string {
        if (!text) {
            return '';
        }

        return this.hypher.hyphenateText(text);
    }
}
